import axios from '@/utils/api.request'
let previousUrl = '/api'
// let previousUrl = 'http://lcs-test.lexuswechat.com/api/holiday'


// 新建休息日
export const addHoliday = (data) => {
	return axios.request({
		url: `${previousUrl}/holiday/add`,
		data: data,
		method: 'post'
	})
}

// 删除休息日
export const delHoliday = (id) => {
	return axios.request({
		url: `${previousUrl}/holiday/${id}`,
		method: 'delete'
	})
}

// 分页
export const getHolidayPost = (pageSize, pageNumber, queryData) => {
	return axios.request({
		url: `${previousUrl}/holiday/list?page=${pageNumber}&size=${pageSize}`,
		data: queryData,
		method: 'post'
	})
}

export const getHolidayGet = (pageSize, pageNumber) => {
	return axios.request({
		url: `${previousUrl}/holiday/list?page=${pageNumber}&size=${pageSize}`,
		method: 'get'
	})
}

export const getDefauleData = (id) => {
	return axios.request({
		url: `${previousUrl}/holiday/${id}`,
		method: 'get'
	})
}

// 获取初始数据
export default () => {
	return axios.request({
		url: `${previousUrl}/holiday/list`,
		method: 'get'
	})
}
